import { WizardStep, FormField } from '../../types';
import { EnhancedDynamicForm } from '../EnhancedDynamicForm';

interface DynamicStepProps {
  step: WizardStep;
  fields: FormField[];
  jiraKey: string;
  invalidFields?: string[];
  onFieldChange?: () => void;
}

export default function DynamicStep({
  step,
  fields,
  jiraKey,
  invalidFields = [],
  onFieldChange,
}: DynamicStepProps) {
  void onFieldChange;
  // Filter fields for this step
  const stepFields = fields.filter(field => step.fields.includes(field.name));

  return (
    <div className="space-y-6">
      {/* Use EnhancedDynamicForm with section support - truly plug-and-play! */}
      <EnhancedDynamicForm
        fields={stepFields}
        sections={step.sections}
        jiraKey={jiraKey}
        invalidFields={invalidFields}
      />

      {/* Information Box - can be customized per step */}
      {step.id === 'testing' && (
        <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-blue-800">
                Testing & Integration Requirements
              </h3>
              <div className="mt-2 text-sm text-blue-700">
                <p>
                  The VersiRent test account will be used to verify the integration works correctly. 
                  The tester emails will receive test builds of your app for quality assurance. 
                  The Google Play Brand Asset Agreement is required for Google Play Store approval.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
